import { createAction } from 'redux-act';
import { getNotifications } from '../../../api/notifications';
import { normalizeNotifications } from '../../../service/notifications';

export const notificationsLoading = createAction('notifications loading');
export const setNotifications = createAction('set notifications');

export const fetchNotifications =
  ({ silent } = {}) =>
  async (dispatch) => {
    if (!silent) dispatch(notificationsLoading(true));
    try {
      const response = await getNotifications();
      if (response.status === 200) {
        const data = await response.json();
        dispatch(setNotifications(normalizeNotifications(data)));
      } else if (!silent) {
        dispatch(setNotifications([]));
      }
    } catch {
      if (!silent) dispatch(setNotifications([]));
    } finally {
      if (!silent) dispatch(notificationsLoading(false));
    }
  };
